import { Controller } from "stimulus";
import displayFlashMessage from "../../functions/displayFlashMessage";

export default class extends Controller {
  static get targets() {
    return ["value", "button"];
  }

  handleHitCopy(event) {
    event.preventDefault();
    const value = this.buttonTarget.dataset.value;
    this._copyToStandardClipboard(value) || this._copyToInternetExplorerClipboard(value);
    displayFlashMessage(this.buttonTarget.dataset.notificationText);
  }

  _copyToInternetExplorerClipboard(value) {
    if (!this.internetExplorerClipboard) {
      return false;
    }

    this.internetExplorerClipboard.setData("Text", value);
    return true;
  }

  _copyToStandardClipboard(value) {
    if (!this.standardClipboard) {
      return false;
    }

    this.standardClipboard.writeText(value);
    return true;
  }

  get internetExplorerClipboard() {
    return window.clipboardData;
  }

  get standardClipboard() {
    return navigator.clipboard;
  }
}
